import { Component, Input, OnInit, Output } from '@angular/core';
import { Contract, Lane, Spot, Violation } from 'src/app/core/models';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.sass']
})
export class ListComponent implements OnInit {

  @Input() lastData: Violation;
  @Input() violations: Violation[] = [];
  @Input() violationData: Array<{ passId: string; spot: Spot; lane: Lane }> = [];
  @Input() loadingList = false;
  @Input() contract: Contract;
  @Output() selectedViolation = new EventEmitter<Violation>();

  constructor() { }

  ngOnInit(): void { }

  getSpotByPassId(passId) {
    const spot = this.violationData.find(a => a.passId === passId)?.spot?.code;
    return spot || '';
  }

  selectViolation(violation: Violation) {
    this.selectedViolation.emit(violation);
    const event = new CustomEvent('selectedViolation', { detail: violation });
    document.dispatchEvent(event);
  }

  getRegulationColor(regulationId: number) {
    const target = this.contract?.ContractConfigColors?.find(a => a.regulationId === regulationId);
    if (target !== undefined) {
      return target.color;
    }
    return '';
  }

}
